/**
 * Returns the percentage the input value represents from the total.
 * @param value - given value
 * @param total - given total sum of values
 * @param allowNegativeValues - If false all negative values will be changed to positive
 * @internal
 */
export const getRelativeValue = (
  value: number,
  total: number,
  allowNegativeValues: boolean = true,
) => {
  if (total === 0) {
    return 0;
  }

  const numberValue = isNaN(value) ? 0 : value;

  const currentValue = allowNegativeValues
    ? numberValue
    : Math.abs(numberValue);

  const isNegativeValue = value < 0;
  const math = Math[isNegativeValue ? 'ceil' : 'floor'];
  // move the comma by 3 places before flooring to keep precision
  return math((currentValue / total) * 1000) / 10;
};
